export default __webpack_public_path__ + "static/media/Logo.405cda41.svg";